module.exports = __webpack_public_path__ + "static/media/lock-closed-outline.c2225f94.svg";